import { useState } from "react"

const ProjectItem = ({ project }) => {
	const [imageIndex, setImageIndex] = useState(0)
	const [timeoutFunc, setTimeoutFunc] = useState()

	const notPublishedProjects = ["Pescuit Cost"]

	const handleClick = ev => {
		ev.preventDefault()
		alert("Proiectul nu mai este publicat")
	}

	const { pictures, link, title } = project

	const isPublished = !notPublishedProjects.includes(title)

	const handleHover = () => {
		const changeIndex = () => {
			setImageIndex(i => {
				const nextIndex = i + 1 === pictures.length ? 0 : i + 1
				return nextIndex
			})

			setTimeoutFunc(setTimeout(changeIndex, 1200))
		}

		setTimeoutFunc(setTimeout(changeIndex, 1200))
	}

	const handleStopHover = () => {
		clearTimeout(timeoutFunc)
		setImageIndex(() => 0)
	}

	return (
		<a
			style={{
				backgroundImage: `url(${pictures[imageIndex]})`,
			}}
			href={isPublished ? link : undefined}
			onClick={isPublished ? undefined : handleClick}
			className="projects__item"
			onMouseOver={handleHover}
			onMouseOut={handleStopHover}
		>
			<div className="projects__item__overlay">
				<span>{title}</span>
			</div>
		</a>
	)
}

export default ProjectItem
